/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiKey } from "./ApiKey";
import {
  ApiKeyFromJSON,
  ApiKeyFromJSONTyped,
  ApiKeyToJSON,
  ApiKeyToJSONTyped,
} from "./ApiKey";

/**
 *
 * @export
 * @interface CompanyApiData
 */
export interface CompanyApiData {
  /**
   *
   * @type {Array<ApiKey>}
   * @memberof CompanyApiData
   */
  apiKeys: Array<ApiKey>;
}

/**
 * Check if a given object implements the CompanyApiData interface.
 */
export function instanceOfCompanyApiData(
  value: object,
): value is CompanyApiData {
  if (!("apiKeys" in value) || value["apiKeys"] === undefined) return false;
  return true;
}

export function CompanyApiDataFromJSON(json: any): CompanyApiData {
  return CompanyApiDataFromJSONTyped(json, false);
}

export function CompanyApiDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyApiData {
  if (json == null) {
    return json;
  }
  return {
    apiKeys: (json["apiKeys"] as Array<any>).map(ApiKeyFromJSON),
  };
}

export function CompanyApiDataToJSON(json: any): CompanyApiData {
  return CompanyApiDataToJSONTyped(json, false);
}

export function CompanyApiDataToJSONTyped(
  value?: CompanyApiData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    apiKeys: (value["apiKeys"] as Array<any>).map(ApiKeyToJSON),
  };
}
